import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { getSelected } from '../FormEditor/Editor/editorSlice';
import FieldOptions from './FieldOptions';
import RequiredOption from './RequiredOption';
import { getForm } from '../FormSetup/formSlice';
import InputOption from './InputOption';

const EditFieldSidebar = () => {
  const field = useSelector(getSelected);
  const { messages: { 'string-empty': { value: defaultMessage } } } = useSelector(getForm);

  return (

    <Box color="gray.600" fontSize="sm" my="4">
      {field && (
      <>
        <InputOption label="Key" field={field} path="key" />
        {(!['Text'].includes(field.type)) && (
        <InputOption label="Label" field={field} path="props.label.value" />
        )}
        {(!['Submit', 'Text', 'Checkbox', 'Radio'].includes(field.type)) && (
        <InputOption label="Placeholder" field={field} path="props.placeholder.value" />
        )}

        {(!['Submit', 'Text', 'Checkbox', 'Radio'].includes(field.type)) && (
        <RequiredOption field={field} defaultMessage={defaultMessage} />
        )}
        <FieldOptions field={field} />
      </>
      )}
    </Box>

  );
};

export default EditFieldSidebar;
